<template>
  <div class="button-leave__wrapper">
    <BimButton
      class="button-leave"
      @click="showModal = true"
      :label="label"
    />
    <bimPhoneRequest
      v-model="showModal"
      :userContext="user_info"
      :logActionEvent="$logActionEvent"
      apiPrefix="/web-api-2"
      :formType="2"
    />
  </div>
</template>

<script>
import BimPopup from "@bimlib/components/bimPopup";
import BimButton from "@bimlib/components/bimButton";
import bimPhoneRequest from '@bimlib/components/bimPhoneRequest'

export default {
  name: "ButtonLeaveApplication",
  components: {
    BimButton,
    BimPopup,
    bimPhoneRequest
  },
  props: {
    user_info: Object,
    label: String,
  },
  data() {
    return {
      showModal: false
    }
  }
}
</script>

<style lang="scss" scoped>
.button-leave__wrapper {
  .button-leave {
    padding: 21px 48px;
    height: auto;
    font-size: 18px;
    line-height: 1.44;
    font-weight: bold;
    white-space: normal;
  }
}
</style>
